import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Plane, Network, Cloud } from "lucide-react";

export default function Hero() {
  const navigate = useNavigate();
  const scrollOrNav = (target) => {
    if (target.startsWith("#")) {
      document.getElementById(target.slice(1))?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate(target);
    }
  };

  return (
    <section id="top" data-testid="hero-section" className="hero-bg noise snap-section overflow-hidden">
      <div
        aria-hidden
        className="hidden lg:block absolute right-0 top-0 bottom-0 w-[45%] pointer-events-none"
        style={{
          backgroundImage: "url('/images/hero-aviation.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.14,
          maskImage: "linear-gradient(90deg, transparent 0%, black 40%, black 100%)",
          WebkitMaskImage: "linear-gradient(90deg, transparent 0%, black 40%, black 100%)",
        }}
      />

      <div className="max-w-[1280px] mx-auto px-6 w-full relative z-10">
        <div className="max-w-3xl">
          <div className="chip mb-5" data-testid="hero-chip">
            <span className="chip-dot" />
            Leading Innovation in IT &amp; Aviation
          </div>

          <h1
            data-testid="hero-title"
            className="text-white font-bold leading-[1.02] mb-4"
            style={{ fontSize: "clamp(38px, 5.5vw, 72px)", fontFamily: "Sora, sans-serif" }}
          >
            EmirATech <br />
            <span style={{
              background: "linear-gradient(135deg, #3b74d1 0%, #6bd6bd 60%, #ff7c76 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
            }}>
              Distribution
            </span>
          </h1>

          <p
            data-testid="hero-tagline"
            className="text-[#c8d4ea] mb-4"
            style={{ fontSize: "clamp(17px, 1.9vw, 22px)", fontFamily: "Sora, sans-serif", fontWeight: 500 }}
          >
            Bridging Technologies. Elevating Skies
          </p>

          <p data-testid="hero-description" className="text-[#a6b3c8] leading-relaxed mb-7 max-w-2xl" style={{ fontSize: "clamp(14px, 1.05vw, 16px)" }}>
            Leading provider of air traffic management and IT solutions, specializing in
            import and export of cutting-edge hardware, software, and AI-driven technologies
            across the Middle East and Central Asia.
          </p>

          <div className="flex flex-wrap gap-4">
            <button data-testid="hero-cta-services" onClick={() => scrollOrNav("/services")} className="btn-primary">
              Explore Services <ArrowRight size={18} />
            </button>
            <button data-testid="hero-cta-contact" onClick={() => scrollOrNav("/contact")} className="btn-secondary">
              Contact Us
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-10 max-w-4xl">
          {[
            { icon: <Network size={22} />, title: "IT Infrastructure", sub: "Enterprise Solutions", cls: "red" },
            { icon: <Cloud size={22} />, title: "Cloud & AI", sub: "Future-Ready Technology", cls: "green" },
            { icon: <Plane size={22} />, title: "Air Traffic Management", sub: "Advanced ATM Solutions", cls: "" },
          ].map((c, i) => (
            <div
              key={c.title}
              data-testid={`hero-card-${i}`}
              className="glass-card p-5 flex items-start gap-4"
            >
              <div className={`svc-icon ${c.cls}`} style={{ width: 44, height: 44 }}>{c.icon}</div>
              <div>
                <div className="text-white font-semibold text-[14px]" style={{ fontFamily: "Sora, sans-serif" }}>{c.title}</div>
                <div className="text-[#a6b3c8] text-[13px] mt-0.5">{c.sub}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
